import React, { useState, useMemo } from "react";
import { Table, Column } from "fixed-data-table-2";
import { AutoSizer } from "react-virtualized";
import Add from "./add";
import Pagination from "./accessories-pagination";
const productAccessories = window.productAccessories || [];

const addToStorage = (product) => {
	const enquiryProduct = {
		title: product.title,
		description: product.desc,
		image: product.image,
		code: product.code,
		pdf: false,
		count: "1",
	};

	const local = localStorage.getItem("enquiry-product");
	let storage = local ? JSON.parse(local).filter(item => item.code !== enquiryProduct.code) : [];

	if (!local || !local.includes(enquiryProduct.code)) {
		storage.push(enquiryProduct);
		window.dataLayer.push({
			event: "add-product",
			productName: enquiryProduct.title,
			productCode: enquiryProduct.code,
		});
	}

	if (storage.length) {
		localStorage.setItem("enquiry-product", JSON.stringify(storage));
	} else {
		localStorage.removeItem("enquiry-product");
	}

	window.dispatchEvent(new Event("on-storage"));
};

const Accessories = () => {
	const [currentPage, setCurrentPage] = useState(1);
	const hitsPerPage = 7;

	const { hits, numHits } = useMemo(() => {
		const indexOfLastHit = currentPage * hitsPerPage;
		const indexOfFirstHit = indexOfLastHit - hitsPerPage;
		const currentHits = productAccessories.slice(indexOfFirstHit, indexOfLastHit);

		return {
			hits: currentHits,
			numHits: productAccessories.length,
		};
	}, [currentPage]);

	return (
		<div className="configurator__list">
			<div className="table intro-click-marker">
				<AutoSizer disableHeight>
					{({ width }) => (
						<Table
							rowsCount={numHits >= hitsPerPage ? hitsPerPage : numHits}
							rowHeight={90}
							headerHeight={70}
							width={width}
							height={numHits >= hitsPerPage ? 588 : (numHits * 75) + 75}
							touchScrollEnabled
						>
							<Column
								width={100}
								flexGrow={1}
								header={<div className="table__cell table__cell--header table__cell--highlight">Product Image</div>}
								cell={({ rowIndex }) => (
									<div className="table__cell">
										{hits[rowIndex]?.image && (
											<img
												className="modal__product__image push--right"
												src={hits[rowIndex].image}
												width="210"
												height="210"
												alt={hits[rowIndex].title}
											/>
										)}
									</div>
								)}
							/>

							<Column
								width={180}
								flexGrow={1}
								header={<div className="table__cell table__cell--header table__cell--highlight">Product Name</div>}
								cell={({ rowIndex }) => (
									<div className="table__cell table__cell--xs">
										<span>{hits[rowIndex]?.title}</span>
									</div>
								)}
							/>

							<Column
								width={220}
								flexGrow={1}
								header={<div className="table__cell table__cell--header table__cell--highlight">Product Code</div>}
								cell={({ rowIndex }) => (
									<div className="table__cell table__cell--xs">{hits[rowIndex]?.code}</div>
								)}
							/>

							<Column
								width={400}
								flexGrow={1}
								header={<div className="table__cell table__cell--header table__cell--highlight">Product Description</div>}
								cell={({ rowIndex }) => (
									<div className="table__cell table__cell--xs">{hits[rowIndex]?.desc}</div>
								)}
							/>

							<Column
								width={150}
								flexGrow={1}
								header={<div className="table__cell table__cell--header table__cell--highlight">Body Colour</div>}
								cell={({ rowIndex }) => (
									<div className="table__cell table__cell--xs">{hits[rowIndex]?.colour}</div>
								)}
							/>

							<Column
								width={100}
								flexGrow={1}
								header={<div className="table__cell table__cell--header table__cell--highlight" />}
								cell={({ rowIndex }) => (
									<div className="table__cell table__cell--highlight table__cell--accessories">
										<Add
											id={hits[rowIndex]?.id}
											addToStorage={() => addToStorage(hits[rowIndex])}
										/>
									</div>
								)}
							/>
						</Table>
					)}
				</AutoSizer>
			</div>
			<Pagination
				hitsPerPage={hitsPerPage}
				numHits={numHits}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
		</div>
	);
};
export default Accessories;